module.exports = __webpack_public_path__ + "img/1_CN_ChineseMicrosite_Homepage_HeroImage.042d1721.jpg";